/* eslint-disable no-param-reassign */
export const formatName = (name: string): string => {
  return name
    .toLowerCase()
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
};

export const abbreviateName = (fullName: string, maxSize: number): string => {
  const words = fullName.trim().split(" ");

  // If only one word, return as is
  if (words.length === 1) {
    return fullName.length > maxSize
      ? fullName.substring(0, maxSize - 1) + "."
      : fullName;
  }

  const firstName = words[0];
  const lastName = words[words.length - 1];

  // If 2 words and exceeds maxSize, abbreviate lastName
  if (words.length === 2) {
    const fullResult = `${firstName} ${lastName}`;
    if (fullResult.length > maxSize) {
      return `${firstName} ${lastName.charAt(0)}.`;
    }
    return fullResult;
  }

  // 3+ words: abbreviate middle names
  const middleWords = words.slice(1, -1);
  const abbreviatedMiddle = middleWords
    .filter((word) => word.length > 2)
    .map((word) => word.charAt(0).toUpperCase() + ".")
    .join(" ");

  let result;
  if (abbreviatedMiddle) {
    result = `${firstName} ${abbreviatedMiddle} ${lastName}`;
  } else {
    result = `${firstName} ${lastName}`;
  }

  // If still too long, abbreviate lastName too
  if (result.length > maxSize) {
    const lastNameAbbreviated = lastName.charAt(0).toUpperCase() + ".";
    if (abbreviatedMiddle) {
      result = `${firstName} ${abbreviatedMiddle} ${lastNameAbbreviated}`;
    } else {
      result = `${firstName} ${lastNameAbbreviated}`;
    }
  }

  return result;
};
